
import { script } from '@utils/script.js';
import { tokenObj } from '@js/tokenParams.js';

// import { newQuery } from '@tencent/slug-function';

// 上报任务暂存队列
const reportTask = [];
const {
  // acctype,
  platid,
  openid,
  // roleid,
  // partition,
  areaid,
  agent,
  channel,
} = tokenObj;
const _initReport = async () => {
  if (process.env.RUNNER === 'server') return;
  await script({
    url: 'https://ossweb-img.qq.com/images/js/eas/eas.js',
  });
  // 上报和曝光.
  window.EAS.need('iu', () => {
    // v3攻略视频内容曝光上报
    // const {
    // 	openid: openId,
    // 	areaid,
    // 	agent,
    // 	channel
    // } = tokenObj;
    window.EAS.iu.init(
      {
        userId: openid,
        openId: openid,
        agent,
        channel,
        area: `${platid}_${areaid}`, // platid:0是ios,1是安卓。areaid:1是wx,2是手Q
        serviceType: 'cjm',
        iuName: 'iu_cjm',
      },
      () => {
        let task = null;
        // 清空队列
        while ((task = reportTask.shift())) {
          _report(task);
        }
      },
    );
  });
};
const _report = (params = {}) => {
  if (process.env.RUNNER === 'server') return;
  const defaultOpts = {
    actionType: '', // 事件类型,必填
    clickUrl: '', // 点击url,必填,'#/video-detail/280555',多个用'|'隔开
    adtag: '', // adtag
    contentId: '', // 点击id,必填,字段取iVideoId/inewsId,多个用'|'隔开
    contentType: '', // 内容类型,必填,取'video'/'news'
    contentSource: '', // 内容来源,必填,取'video.tuijian.0.0.list'五级
    contentCategory: '', // 内容分类
  };
  const config = Object.assign({}, defaultOpts, params);
  // if (!config.adtag) config.adtag = '';
  if (!window.EAS || !window.EAS.iu) {
    reportTask.push(config);
    _initReport();
    return;
  }

  return window.EAS.iu.click(config);
};
// reportPop:function(clickUrl,contentId,type,category,source,adtag,docid,algoid,recid){
// reportV4:function(acType, url, id, tType, source, cType,adtag,docid,algoid,recid){
// v4原始pv
export const reportV4 = (params = {}) => {
  _report(Object.assign({}, params));
};
// reportPageView:function(id,type,source,acType,adtag,docid,algoid,recid){
// v4pv上报，传入文章或者视频id，type类型
// export const reportPageView = (params = {}) => {
//   const defaultOpts = {
//     actionType: 'pv', // 事件类型
//     contentSource: 'detail',
//   };
//   _report(Object.assign({}, defaultOpts, params));
// };
// reportV4TimeLine:function(stayTime, url, id, tType, source, cType){
// v4页面停留时长上报
// export const reportV4TimeLine = (params = {}) => {
//   const defaultOpts = {
//     actionType: 'timeline', // 事件类型
//     stayTime: '', // 停留时长 /s
//   };
//   _report(Object.assign({}, defaultOpts, params));
// };
// 点击流pv/uv上报
export const setReportTcss = (opts) => {
  // if (process.env.RUNNER === 'server') return;
  window.setSite = {
    siteType: 'os',
    pageType: opts.type,
    pageName: opts.name,
    project: 'base',
    osact: 'ingame',
  };
  if (typeof pgvMain === 'function') {
    // 手动触发pv uv统计
    pgvMain({
      repeatApplay: 'true',
      virtualURL: opts.path,
      virtualDomain: 'gp.qq.com',
    });
  } else {
    const tcssSrc = '//ossweb-img.qq.com/images/js/PTT/ping_tcss_tgideas_https_min.js';
    const tcssjs = document.createElement('script');
    tcssjs.onload = function () {
      // 手动触发pv uv统计
      pgvMain && pgvMain({
        repeatApplay: 'true',
        virtualURL: opts.path,
        virtualDomain: 'gp.qq.com',
      });
    };
    tcssjs.src = tcssSrc;
    document.body.appendChild(tcssjs);
    window.Sentry.captureMessage(new Error('pttjs加载异常'));
  }
};
// export const PTTSendClick = (text, level1, level2) => {
//   window.PTTSendClick && window.PTTSendClick(text, level1, level2, 'gp.qq.com');
// };
// export const PTTSendReport = (params) => {
//   window.PTTSendReport && window.PTTSendReport(params);
// };
// 华佗性能监控，pids表示监控标识前缀
// export const reportSpeed = (pids, kvs) => {
//   if (process.env.RUNNER === 'server') return;
//   pids = pids.split('-');
//   const url =    '//report.huatuo.qq.com/report.cgi?appid=20682&platform=h5&speedparams=';
//   let s = `flag1=${pids[0]}&flag2=${pids[1]}&flag3=${pids[2]}&flag5=3`;
//   for (const key in kvs) {
//     s += `&${key}=${kvs[key]}`;
//   }
//   const imgSendTimePoint = new Image();
//   imgSendTimePoint.src = url + encodeURIComponent(s);
// };
// 用户停留时长
// export const getUserAction = (opt) => {
  // if (process.env.RUNNER === 'server') return
  // let token = window.sessionStorage.tokenParams;
  // if (!token) return;
  // let pageid_str = opt.pageid ? ('&pageid=' + opt.pageid) : '';
  // let stayTime_str = opt.stayTime ? ('&staytime=' + opt.stayTime) : '';
  // let path_str = opt.path ? ('&path=/v2' + opt.path) : '';
  // let oImg = document.createElement('IMG');
  // oImg.src = `//app.ingame.qq.com/php/ingame/useraction/user_action.php${token}${pageid_str}${stayTime_str}${path_str}&gameid=pg&sourceid=ingame`;
  // window.localStorage.reportUserAction = oImg.src;
  // oImg.onload = () => {
  // 	window.localStorage.removeItem('reportUserAction');
  // };
// };
// 用户行为上报
// export const reportUserAction = ({
//   routeName,
//   reportType,
//   contentType,
//   items = [],
// }) => {
//   if (process.env.RUNNER === 'server') return;
//   // export const reportUserAction = (bodyArr) => {
//   const dt = new Date().getTime();
//   const body = [];
//   items.forEach((item) => {
//     const bodyArr = [
//       'pg',
//       acctype || '',
//       platid || '',
//       openid || '',
//       partition || '',
//       roleid || '',
//       routeName,
//       item.contentId,
//       reportType,
//       '',
//       contentType || item.contentType,
//       item.contentTag,
//       encodeURI(item.contentTitle),
//       'v4',
//     ];
//     body.push(bodyArr.join('|'));
//   });
//   const reportBody = body.join(';');
//   // 上报内容格式：
//   // game|acctype|platid|openid|partition|roleid|页面id|文章id|
//   // view(曝光)或者click(点击)||video（视频）或picture(图文) 或 文章(article) |
//   // 文章标签|文章标题|来源 ：tgl或者v4
//   // const formData = new FormData();
//   // formData.append('dt', dt);
//   // formData.append('body', encodeURI(reportBody));
//   post({
//     url: '//dmplog.qq.com/useraction/report/ingame',
//     data: newQuery({
//       dt,
//       body: reportBody,
//     }),
//     isToken: false,
//   })
//     .then(() => {})
//     .catch(() => {});
// };
// 点击用户行为上报
// export const reportUserActionClick = (params = {}) => {
//   reportUserAction(Object.assign(
//     {
//       reportType: 'click',
//     },
//     params,
//   ));
// };
// // 曝光用户行为上报
// export const reportUserActionPop = (params = {}) => {
//   reportUserAction(Object.assign(
//     {
//       reportType: 'view',
//     },
//     params,
//   ));
// };
// v4点击上报
export const reportV4Click = (params = {}) => {
  _report(Object.assign(
    {
      actionType: 'click',
    },
    params,
  ));
};
// v4曝光上报,批量多个
export const reportV4Pop = (params = {}) => {
  _report(Object.assign(
    {
      actionType: 'pop',
    },
    params,
  ));
};
// 点击上报,包括v4上报和用户行为上报,单个上报
export const reportClick = (
  v4ExtParams = {},
  // useractionExtParams = {},
  reportItem = {},
) => {
  const contentId = reportItem.iVideoId || reportItem.iNewsId || reportItem.iId;
  reportV4Click(Object.assign({}, v4ExtParams, {
    contentId,
  }));
  // reportUserActionClick(Object.assign({}, useractionExtParams, {
  //   items: [
  //     {
  //       contentId,
  //       contentTag: reportItem.sTagIds,
  //       contentTitle: reportItem.sTitle,
  //     },
  //   ],
  // }));
};
// 曝光上报,存在批量上报的情况
export const reportPop = (
  v4ExtParams = {},
  // useractionExtParams = {},
  reportItems = [],
) => {
  if (process.env.RUNNER === 'server') return;
  const contentIds = [];
  // const items = [];
  const clickUrls = [];
  const v4contentTypes = [];
  reportItems.forEach((item) => {
    const contentId = item.iVideoId || item.iNewsId || item.iId;
    clickUrls.push(v4ExtParams.clickUrl || item.clickUrl + contentId);
    contentIds.push(contentId);
    if (item.v4contentType) v4contentTypes.push(item.v4contentType);
    // items.push({
    //   contentId,
    //   contentTag: item.sTagIds || '',
    //   contentTitle: item.sTitle,
    //   contentType: item.useractioncontentType,
    // });
  });
  reportV4Pop(Object.assign({}, v4ExtParams, {
    contentId: contentIds.join('|'),
    clickUrl: clickUrls.join('|'),
  }));
  // reportUserActionPop(Object.assign({}, useractionExtParams, {
  //   items,
  // }));
};
